export default "__VITE_ASSET__cebc36c5__"